class CscLoad {

    constructor() {
    }

    convertCsvFormat = (json) => {
        var fields = json.length > 0 ? Object.keys(json[0]) : [];
        var replacer = function (key, value) { return value === null ? '' : value }
        var csv = json.map(function (row) {
            return fields.map(function (fieldName) {
                return JSON.stringify(row[fieldName], replacer)
            }).join(',')
        })
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');
        return csv;
    }
    // transpose the array
    transpose = (arr) => {
        if(arr && arr.length>0){
            return Object.keys(arr[0]).map(function (c) {
                return arr.map(function (r) {
                    if (r[c] == null) {
                        r[c] = "";
                    }
                    return r[c];
                });
            });
        }
    }

    CSVParseToArray = (csvString) => {
        let delimiter = ","

        if (!csvString || !csvString.length)
            return [];

        const pattern = new RegExp(
            ("(\\" + delimiter + "|\\r?\\n|\\r|^)" +
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
                "([^\"\\" + delimiter + "\\r\\n]*))"
            ), "gi"
        );

        let rows = [[]];
        let matches = false;

        while (matches = pattern.exec(csvString)) {

            const matched_delimiter = matches[1];
            const matched_cellQuote = matches[2];
            const matched_cellNoQuote = matches[3];

            /*
            * Edge case: Data that starts with a delimiter
            */
            if (matches.index == 0 && matched_delimiter)
                rows[rows.length - 1].push("");

            /*
            * Fix empty lines
            */
            if (!matches[2] && !matches[3])
                continue;

            if (matched_delimiter.length && matched_delimiter !== delimiter)
                rows.push([]);

            const matched_value = (matched_cellQuote)
                ? matched_cellQuote.replace(
                    new RegExp("\"\"", "g"), "\""
                )
                : matched_cellNoQuote;

            rows[rows.length - 1].push(matched_value);

        }

        return rows;
    }
}

export default new CscLoad();